import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const writeOffs = {
  path: '/write-offs',
  component: Layout,
  name: 'writeOffs',
  redirect: '/write-offs/index',
  children: [{
    path: '/write-offs/index',
    component: () => import('@/views/writeOffs/index'),
    name: 'writeOffs.index',
    meta: {
      title: i18n.t(`message.write_offs`)
    }
  }, ]
}

export default writeOffs;